import React from "react";
import RoadmapLarge from "../../RoadmapLarge/m34";
import { IV2RoadmapProps } from "@/types/V2RoadmapTypes";

export default class M34 extends React.Component<IV2RoadmapProps> {
	render() {
		const p = this.props;
		
		return <RoadmapLarge
					pcode={p.pcode}
					mobile={p.mobile}
					history={p.history}
					historyBlink={p.historyBlink}
					lobbyMobile={p.lobbyMobile}
					type={"big-road"}
					small={p.small || true} />;
	}
}